module.exports = __webpack_public_path__ + "img/library-white.3ff06722.png";